var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"200px auto","width":"300px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.exportShopFun}},[_vm._v("门店下载")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.exportRegistrationFun}},[_vm._v("礼堂下载")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }